export default {
  booked: 'Booked',
  canceled: 'Canceled',
  reservedCompany: 'Reserved admin',
  reservedUser: 'Reserved user',
  reservationCanceled: 'Canceled'
}